module.exports = __webpack_public_path__ + "img/logo-light.caa4b5d8.png";